<div class="d-flex">
  <!-- Form -->
  <form (ngSubmit)="this.form.submit()" [formGroup]="this.form" class=" flex-grow-1">

    <div class="row">
      <div class="col-12">
        <app-alert-messages maximumNumberOfMessages="1"></app-alert-messages>
      </div>
    </div>

    <div class="row mt-5">
      <div class="col-12">
        <h2 id="capital-actions-societe-cessionnaire"> Capital-actions de la société cessionnaire </h2>

        <div class="row">
          <div class="col-12 col-sm-8 col-md-6 col-lg-6 col-xl-4">
            <!-- buyerCorporation -->
            <magieno-input-text-field [advancedFormControl]="this.buyerCorporation"
                                  type="string"></magieno-input-text-field>
          </div>
        </div>

        <!-- signatureDate -->
        <magieno-datepicker
                [advancedFormControl]="this.signatureDate">
          <i class="fas fa-calendar" calendarIcon></i>
        </magieno-datepicker>

        <!-- productionDeadline -->
        <magieno-datepicker
                [advancedFormControl]="this.productionDeadline">
          <i class="fas fa-calendar" calendarIcon></i>
        </magieno-datepicker>

      </div>
    </div> <!-- / .row -->

    <app-rollover-share-holders-form [form]="this.form"></app-rollover-share-holders-form>

    <app-rollover-share-classes-form #shareClasses [form]="this.form"></app-rollover-share-classes-form>

    <app-rollover-properties-form #properties [form]="this.form"
                                  [propertyTransferred]="this.propertiesTransferred"></app-rollover-properties-form>

    <br>
    <br>
    <br>
    <br>

    <!-- Button -->
    <div class="row fixed-bottom">
      <div class="col-12">
        <magieno-button [button]="this.form.getButton('SAVE')" id="saveCalculationButton"></magieno-button>

        <magieno-button [button]="this.form.getButton('EXECUTE')" id="executeCalculationButton"
                    style="margin-left: 12px"></magieno-button>

        <span [class.bg-danger]="calculationStatusEnum === 'ERROR'"
              [class.bg-light]="calculationStatusEnum === 'CREATED'"
              [class.bg-success]="calculationStatusEnum === 'COMPLETED'"
              [class.bg-warning]="calculationStatusEnum === 'IN_PROGRESS'"
              class="badge rounded-pill"
              style="margin-left: 25px;
    font-size: 12pt;"

        >{{ getStatusText() }}</span>

        <button (click)="openErrorsSidebar()" [class.bg-danger]="this.numberOfErrors > 0"
                [class.bg-success]="this.numberOfErrors === 0"
                class="badge rounded-pill ms-3"
                style="font-size: 12pt;">{{ this.numberOfErrors }}
          erreurs
        </button>

        <span style="margin-left: 15px;">Dernière sauvegarde: <strong>{{ getLastModifiedText() }}</strong></span>

      </div>
    </div>


  </form>

  <app-calculation-form-sidebar></app-calculation-form-sidebar>
</div>
